// ════════════════════════════════════════════════════════════════════════
// PACT.HEALTH · mockData.js
// All demo data lives here. Switch back to Supabase later by importing
// from supabase queries instead of from this file.
// ════════════════════════════════════════════════════════════════════════

const today = new Date();
const daysAgo = (n) => { const d = new Date(today); d.setDate(d.getDate() - n); return d.toISOString().split('T')[0]; };

// Helper to generate a 7-day mood array
const moods7 = (avg) => [...Array(7)].map((_, i) => ({
  date: daysAgo(6 - i),
  rating: Math.max(1, Math.min(5, Math.round(avg + (Math.random() - 0.5) * 1.4))),
  created_at: daysAgo(6 - i),
}));

// Helper to generate week of health_data
const weekData = ({ steps, calories, protein, carbs, fat }) =>
  [...Array(7)].map((_, i) => ({
    date: daysAgo(6 - i),
    steps: Math.round(steps + (Math.random() - 0.5) * steps * 0.3),
    calories: Math.round(calories + (Math.random() - 0.5) * calories * 0.15),
    protein: Math.round(protein + (Math.random() - 0.5) * protein * 0.2),
    carbs: Math.round(carbs + (Math.random() - 0.5) * carbs * 0.2),
    fat: Math.round(fat + (Math.random() - 0.5) * fat * 0.2),
    created_at: daysAgo(6 - i),
  }));

// Helper for weigh-in history
const weighIns = (start, current, weeks = 12) => {
  const arr = [];
  const step = (current - start) / (weeks - 1);
  for (let i = 0; i < weeks; i++) {
    const date = daysAgo((weeks - 1 - i) * 7);
    arr.push({
      date, weight: +(start + step * i + (Math.random() - 0.5) * 0.4).toFixed(1),
      day_type: i % 2 === 0 ? 'monday' : 'friday'
    });
  }
  return arr;
};

// ── Athletes ────────────────────────────────────────────────────────────
export const ATHLETES = [
  {
    id: 'alex-001', name: 'Alex Joyner', goal: 'fat_loss', gym: 'PureGym',
    onboarding_complete: true,
    start_weight: 90.6, current_weight: 86.4, target_weight: 85.0,
    step_target: 10000, calorie_target: 2200, protein_target: 175,
    whatsapp_phone: '+447700900100',
    fitness_level: 'intermediate',
    join_date: '2025-01-15',
  },
  {
    id: 'sarah-002', name: 'Sarah Mitchell', goal: 'fat_loss', gym: 'PureGym',
    onboarding_complete: true,
    start_weight: 76.5, current_weight: 70.3, target_weight: 63.0,
    step_target: 10000, calorie_target: 1800, protein_target: 130,
    whatsapp_phone: '+447700900200',
    fitness_level: 'intermediate',
    join_date: '2024-11-08',
  },
  {
    id: 'james-003', name: 'James Harper', goal: 'muscle_building', gym: 'David Lloyd',
    onboarding_complete: true,
    start_weight: 78.8, current_weight: 79.6, target_weight: 85.0,
    step_target: 8000, calorie_target: 2800, protein_target: 200,
    whatsapp_phone: '+447700900300',
    fitness_level: 'advanced',
    join_date: '2024-09-20',
  },
  {
    id: 'emma-004', name: 'Emma Clarke', goal: 'recomposition', gym: 'Home gym',
    onboarding_complete: true,
    start_weight: 65.2, current_weight: 64.0, target_weight: 60.0,
    step_target: 9000, calorie_target: 1900, protein_target: 130,
    whatsapp_phone: '+447700900400',
    fitness_level: 'beginner',
    join_date: '2025-03-04',
  },
  {
    id: 'rachel-005', name: 'Rachel Vance', goal: 'strength', gym: 'PureGym',
    onboarding_complete: true,
    start_weight: 68.0, current_weight: 70.2, target_weight: 72.0,
    step_target: 8500, calorie_target: 2400, protein_target: 160,
    whatsapp_phone: '+447700900500',
    fitness_level: 'advanced',
    join_date: '2024-10-12',
  },
  {
    id: 'tom-006', name: 'Tom Brennan', goal: 'fat_loss', gym: 'JD Gyms',
    onboarding_complete: true,
    start_weight: 95.0, current_weight: 93.5, target_weight: 80.0,
    step_target: 10000, calorie_target: 2200, protein_target: 170,
    whatsapp_phone: '+447700900600',
    fitness_level: 'beginner',
    join_date: '2025-03-18',
  },
];

// ── Will, the coach ─────────────────────────────────────────────────────
export const COACH = {
  id: 'Will-coach',
  name: 'Will Young',
  level: 'Lvl 4 PT · 8 years',
  whatsapp_phone: '+447700900001',
};

// ── Per-athlete data (health, moods, weights, etc.) ─────────────────────
export const CLIENT_DATA = {
  'alex-001': {
    health: { steps: 5400, calories: 1850, protein: 60, carbs: 220, fat: 75, created_at: today.toISOString() },
    weekData: weekData({ steps: 5400, calories: 1850, protein: 60, carbs: 220, fat: 75 }),
    prevWeekData: weekData({ steps: 7200, calories: 2050, protein: 95, carbs: 240, fat: 80 }),
    moods: moods7(1.0),
    weighIns: weighIns(90.6, 86.4, 12),
    sessions: [],
    liftHistory: [],
    weekSessions: [
      { date: daysAgo(6), session_name: 'Lower', completed: false, is_rest: false, exercises: [{}, {}] },
      { date: daysAgo(4), session_name: 'Push',  completed: false, is_rest: false, exercises: [{}, {}] },
      { date: daysAgo(2), session_name: 'Pull',  completed: false, is_rest: false, exercises: [{}, {}] },
      { date: daysAgo(1), session_name: 'Cond',  completed: false, is_rest: false, exercises: [{}] },
    ],
    nutritionDays: weekData({ steps: 0, calories: 1850, protein: 60, carbs: 220, fat: 75 }),
    conversations: 1,
    allWeekData: weekData({ steps: 5400, calories: 1850, protein: 60, carbs: 220, fat: 75 }),
  },
  'sarah-002': {
    health: { steps: 11000, calories: 1750, protein: 129, carbs: 165, fat: 60, created_at: today.toISOString() },
    weekData: weekData({ steps: 11000, calories: 1750, protein: 129, carbs: 165, fat: 60 }),
    prevWeekData: weekData({ steps: 12500, calories: 1850, protein: 145, carbs: 175, fat: 65 }),
    moods: moods7(4.5),
    weighIns: weighIns(76.5, 70.3, 12),
    sessions: [], liftHistory: [],
    weekSessions: [
      { date: daysAgo(6), session_name: 'Lower', completed: true,  is_rest: false, exercises: [{}, {}] },
      { date: daysAgo(4), session_name: 'Push',  completed: true,  is_rest: false, exercises: [{}, {}] },
      { date: daysAgo(2), session_name: 'Pull',  completed: false, is_rest: false, exercises: [{}, {}] },
    ],
    nutritionDays: weekData({ steps: 0, calories: 1750, protein: 129, carbs: 165, fat: 60 }),
    conversations: 8,
    allWeekData: weekData({ steps: 11000, calories: 1750, protein: 129, carbs: 165, fat: 60 }),
  },
  'james-003': {
    health: { steps: 8400, calories: 2780, protein: 199, carbs: 274, fat: 89, created_at: today.toISOString() },
    weekData: weekData({ steps: 8400, calories: 2780, protein: 199, carbs: 274, fat: 89 }),
    prevWeekData: weekData({ steps: 8000, calories: 2700, protein: 195, carbs: 268, fat: 87 }),
    moods: moods7(3.8),
    weighIns: weighIns(78.8, 79.6, 12),
    sessions: [], liftHistory: [],
    weekSessions: [
      { date: daysAgo(6), session_name: 'Push',   completed: true,  is_rest: false, exercises: [{}, {}] },
      { date: daysAgo(4), session_name: 'Pull',   completed: true,  is_rest: false, exercises: [{}, {}] },
      { date: daysAgo(2), session_name: 'Legs',   completed: true,  is_rest: false, exercises: [{}, {}] },
      { date: daysAgo(0), session_name: 'Upper',  completed: false, is_rest: false, exercises: [{}] },
    ],
    nutritionDays: weekData({ steps: 0, calories: 2780, protein: 199, carbs: 274, fat: 89 }),
    conversations: 6,
    allWeekData: weekData({ steps: 8400, calories: 2780, protein: 199, carbs: 274, fat: 89 }),
  },
  'emma-004': {
    health: { steps: 3000, calories: 1450, protein: 61, carbs: 145, fat: 55, created_at: today.toISOString() },
    weekData: weekData({ steps: 3000, calories: 1450, protein: 61, carbs: 145, fat: 55 }),
    prevWeekData: weekData({ steps: 4200, calories: 1600, protein: 75, carbs: 160, fat: 60 }),
    moods: moods7(1.3),
    weighIns: weighIns(65.2, 64.0, 12),
    sessions: [], liftHistory: [],
    weekSessions: [
      { date: daysAgo(6), session_name: 'Full body', completed: true,  is_rest: false, exercises: [{}] },
      { date: daysAgo(3), session_name: 'Full body', completed: false, is_rest: false, exercises: [{}] },
    ],
    nutritionDays: weekData({ steps: 0, calories: 1450, protein: 61, carbs: 145, fat: 55 }),
    conversations: 2,
    allWeekData: weekData({ steps: 3000, calories: 1450, protein: 61, carbs: 145, fat: 55 }),
  },
  'rachel-005': {
    health: { steps: 9200, calories: 2400, protein: 162, carbs: 240, fat: 80, created_at: today.toISOString() },
    weekData: weekData({ steps: 9200, calories: 2400, protein: 162, carbs: 240, fat: 80 }),
    prevWeekData: weekData({ steps: 9100, calories: 2380, protein: 160, carbs: 238, fat: 78 }),
    moods: moods7(4.2),
    weighIns: weighIns(68.0, 70.2, 12),
    sessions: [], liftHistory: [],
    weekSessions: [
      { date: daysAgo(6), session_name: 'Squat',     completed: true,  is_rest: false, exercises: [{}, {}] },
      { date: daysAgo(4), session_name: 'Bench',    completed: true,  is_rest: false, exercises: [{}, {}] },
      { date: daysAgo(2), session_name: 'Deadlift', completed: true,  is_rest: false, exercises: [{}, {}] },
      { date: daysAgo(0), session_name: 'Press',    completed: false, is_rest: false, exercises: [{}] },
    ],
    nutritionDays: weekData({ steps: 0, calories: 2400, protein: 162, carbs: 240, fat: 80 }),
    conversations: 12,
    allWeekData: weekData({ steps: 9200, calories: 2400, protein: 162, carbs: 240, fat: 80 }),
  },
  'tom-006': {
    health: { steps: 4100, calories: 2100, protein: 95, carbs: 230, fat: 75, created_at: today.toISOString() },
    weekData: weekData({ steps: 4100, calories: 2100, protein: 95, carbs: 230, fat: 75 }),
    prevWeekData: weekData({ steps: 5500, calories: 2200, protein: 110, carbs: 245, fat: 80 }),
    moods: moods7(2.2),
    weighIns: weighIns(95.0, 93.5, 12),
    sessions: [], liftHistory: [],
    weekSessions: [
      { date: daysAgo(6), session_name: 'Full body', completed: false, is_rest: false, exercises: [{}] },
      { date: daysAgo(3), session_name: 'Full body', completed: false, is_rest: false, exercises: [{}] },
    ],
    nutritionDays: weekData({ steps: 0, calories: 2100, protein: 95, carbs: 230, fat: 75 }),
    conversations: 1,
    allWeekData: weekData({ steps: 4100, calories: 2100, protein: 95, carbs: 230, fat: 75 }),
  },
};

// ── Weekly pact history (per athlete) ───────────────────────────────────
const buildPacts = (clientId, name, weeks, current) => {
  const inits = name.split(' ').map(w => w[0]).join('').toUpperCase();
  return weeks.map((p, i) => ({
    id: `pact-${clientId}-w${i}`,
    client_id: clientId,
    week_start: daysAgo((weeks.length - 1 - i) * 7),
    reference: `PACT-2025-W${String(15 + i).padStart(2, '0')}-${inits}-${1000 + i}`,
    athlete_signed_at: i < weeks.length - 1 ? new Date(Date.now() - (weeks.length - i) * 7 * 86400000).toISOString() : null,
    coach_signed_at: i < weeks.length - 1 ? new Date(Date.now() - (weeks.length - i) * 7 * 86400000 - 3600000).toISOString() : null,
    status: i === weeks.length - 1 ? (current || 'active') : (p.kept === p.committed ? 'kept' : p.kept > 0 ? 'partial' : 'broken'),
    pacts_committed: p.committed,
    pacts_kept: p.kept,
  }));
};

export const PACTS = {
  'alex-001': buildPacts('alex-001', 'Alex Joyner', [
    { committed: 4, kept: 4 },{ committed: 4, kept: 3 },{ committed: 4, kept: 4 },{ committed: 4, kept: 4 },
    { committed: 4, kept: 2 },{ committed: 4, kept: 0 },
  ], 'active'),
  'sarah-002': buildPacts('sarah-002', 'Sarah Mitchell', [
    { committed: 4, kept: 4 },{ committed: 4, kept: 4 },{ committed: 4, kept: 3 },{ committed: 4, kept: 4 },
    { committed: 4, kept: 4 },{ committed: 4, kept: 2 },
  ], 'active'),
  'james-003': buildPacts('james-003', 'James Harper', [
    { committed: 4, kept: 3 },{ committed: 4, kept: 4 },{ committed: 4, kept: 4 },{ committed: 4, kept: 3 },
    { committed: 4, kept: 4 },{ committed: 4, kept: 3 },
  ], 'active'),
  'emma-004': buildPacts('emma-004', 'Emma Clarke', [
    { committed: 3, kept: 1 },{ committed: 3, kept: 2 },{ committed: 3, kept: 1 },{ committed: 3, kept: 1 },
    { committed: 3, kept: 0 },
  ], 'active'),
  'rachel-005': buildPacts('rachel-005', 'Rachel Vance', [
    { committed: 4, kept: 4 },{ committed: 4, kept: 4 },{ committed: 4, kept: 4 },{ committed: 4, kept: 3 },
    { committed: 4, kept: 4 },{ committed: 4, kept: 3 },
  ], 'active'),
  'tom-006': buildPacts('tom-006', 'Tom Brennan', [
    { committed: 3, kept: 1 },{ committed: 3, kept: 0 },{ committed: 3, kept: 0 },
  ], 'active'),
};

// ── Stakes ──────────────────────────────────────────────────────────────
export const STAKES = {
  'alex-001':   { id: 's-alex',   client_id: 'alex-001',   amount: 20,  stake_type: 'charity',     charity_name: 'A charity you don\'t like', trigger_threshold: 2, breaks_so_far: 0, status: 'live' },
  'sarah-002':  { id: 's-sarah',  client_id: 'sarah-002',  amount: 50,  stake_type: 'coach_bonus', charity_name: null,                          trigger_threshold: 2, breaks_so_far: 0, status: 'live' },
  'james-003':  { id: 's-james',  client_id: 'james-003',  amount: 30,  stake_type: 'streak_bond', charity_name: null,                          trigger_threshold: 2, breaks_so_far: 0, status: 'live' },
  'rachel-005': { id: 's-rachel', client_id: 'rachel-005', amount: 100, stake_type: 'visibility',  charity_name: null,                          trigger_threshold: 2, breaks_so_far: 0, status: 'live' },
};

// ── Co-signers ──────────────────────────────────────────────────────────
export const COSIGNERS = {
  'alex-001': [
    { id: 'cs-1', client_id: 'alex-001', name: 'Will Young', relationship: 'coach', whatsapp_phone: '+447700900001' },
    { id: 'cs-2', client_id: 'alex-001', name: 'Jamie',          relationship: 'partner', whatsapp_phone: '+447700900099' },
  ],
  'sarah-002': [
    { id: 'cs-3', client_id: 'sarah-002', name: 'Will Young', relationship: 'coach', whatsapp_phone: '+447700900001' },
  ],
  'james-003': [
    { id: 'cs-4', client_id: 'james-003', name: 'Will Young', relationship: 'coach', whatsapp_phone: '+447700900001' },
    { id: 'cs-5', client_id: 'james-003', name: 'Beth',          relationship: 'sister', whatsapp_phone: '+447700900098' },
  ],
  'rachel-005': [
    { id: 'cs-6', client_id: 'rachel-005', name: 'Will Young', relationship: 'coach', whatsapp_phone: '+447700900001' },
    { id: 'cs-7', client_id: 'rachel-005', name: 'Tom',           relationship: 'training partner', whatsapp_phone: '+447700900097' },
  ],
};

// ── Goals (over-arching pact for each athlete) ──────────────────────────
export const GOALS = {
  'alex-001': {
    deadline: '2026-03-01',
    targets: [
      { metric: 'Weight',    current: '86.4 kg',    target: '85.0 kg',  progress: 75 },
      { metric: 'Squat',     current: '102.5 × 8',  target: '110 × 8',  progress: 60 },
      { metric: 'Bench',     current: '85 × 6',     target: '90 × 6',   progress: 70 },
      { metric: 'Body fat',  current: '17.2%',      target: '15%',      progress: 65 },
    ],
  },
};

// ── Today's pact (Alex's) for the athlete app ───────────────────────────
export const TODAYS_PACT = {
  client_id: 'alex-001',
  date: today.toISOString().split('T')[0],
  pact_number: 1,
  pact_total: 4,
  focus: 'Lower · Squat focus',
  exercises: [
    { name: 'Foam roll + activation', detail: '6 min',          type: 'warmup' },
    { name: 'Barbell Back Squat',     detail: '4 × 8 · +2.5 kg', type: 'main' },
    { name: 'Romanian Deadlift',      detail: '3 × 8 · +5 kg',   type: 'main' },
    { name: 'Walking Lunges',         detail: '3 × 12/leg',      type: 'main' },
    { name: 'Leg Press',              detail: '3 × 10 · +10 kg', type: 'main' },
    { name: 'Calf raise + ham curl',  detail: 'Superset 3 rds',  type: 'super' },
    { name: 'Cool-down stretch',      detail: '5 min',           type: 'cool' },
  ],
  duration_min: 52,
  pax_briefing:
    "Recovery 78, sleep solid, energy good — that tracks. The pact today is the +2.5 kg progression you and Will set Sunday. Hold the line on accessories. Knee tight Friday — flag it before set 2 if it shows.",
};

// ── PAX conversation (Alex's) ───────────────────────────────────────────
export const PAX_MESSAGES = [
  { from: 'pax',  text: "Morning. Recovery 78, sleep solid. Pact 1 of 4 today — the +2.5 kg squat you signed Sunday. Begin when ready.", time: '06:14' },
  { from: 'user', text: "Heads up — knee felt tight on Friday's session.", time: '06:32' },
  { from: 'pax',  text: "Logged with Will. Stake's still safe at 0 of 2. If knee shows up today, drop the load — pact still kept.", time: '06:32' },
  { from: 'user', text: "Sounds good. Eating breakfast first.", time: '06:33' },
  { from: 'pax',  text: "Stick to your usual pre-lift. You're 1.4 kg from target — keep portions tight today.", time: '06:34' },
];

// ── Recent wins (across all athletes, for coach dashboard) ──────────────
export const RECENT_WINS = [
  { who: 'Rachel V.', what: 'Bench PR · 70 kg × 5',   when: '5h ago' },
  { who: 'Alex J.',   what: 'Squat PR · 102.5 × 8',   when: '12m ago' },
  { who: 'Sarah M.',  what: '4-week pact streak',     when: 'Today' },
  { who: 'James H.',  what: 'Hit 200g protein 7 days', when: 'Yesterday' },
];

// ── Helpers ─────────────────────────────────────────────────────────────
export function getCurrentPact(clientId) {
  const list = PACTS[clientId] || [];
  return list.find(p => p.status === 'active') || list[list.length - 1] || null;
}
